import { EventEmitter, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { LoginService } from '../../../services/login.service';
import { FormBuilder, Validators } from '@angular/forms';
var ForgotPasswordComponent = /** @class */ (function () {
    function ForgotPasswordComponent(userService, loginService, fb) {
        this.userService = userService;
        this.loginService = loginService;
        this.fb = fb;
        this.showForgotPassword = new EventEmitter();
        this.emailSent = false;
        this.forgotForm = this.fb.group({
            email: ['', Validators.required]
        });
    }
    ForgotPasswordComponent.prototype.ngOnInit = function () {
        if (this.email)
            this.forgotForm.setValue({ email: this.email });
    };
    ForgotPasswordComponent.prototype.onSubmit = function () {
        var _this = this;
        this.loginService.sendForgotPasswordEmail(this.forgotForm.get('email').value).then(function (response) {
            _this.emailSent = true;
        });
    };
    Object.defineProperty(ForgotPasswordComponent.prototype, "forgotEmail", {
        get: function () {
            return this.forgotForm.get('email');
        },
        set: function (val) {
            this.forgotForm.get('email').setValue(val);
        },
        enumerable: true,
        configurable: true
    });
    return ForgotPasswordComponent;
}());
export { ForgotPasswordComponent };
